import { useMemo } from 'react';
import { useGlobalStore } from '@core/hooks/useGlobalStore';
import { videoFactory } from '@core/hydration';
import { isLiveStream } from '@core/livestream/helpers';
import flatten from '@core/lodash/flatten';
import { logInfo } from '@core/logging';
import { productsHydratedSelector, shoppingActionsSelector, } from '@core/shopping/model';
import { productFactory } from '@core/shopping/utils/factories/product';
import { getGlobalStore } from '@core/store';
import { useStoreApi } from '../store';
/**
 *
 */
export const useCustomEventPlayerActions = () => {
    const storeApi = useStoreApi();
    const { configureCart, updateUnitCartQuantity, resetCart, hydrateProducts } = useGlobalStore(shoppingActionsSelector);
    return useMemo(() => ({
        shopping: {
            hydrateProduct: (callback) => {
                const product = callback({ productFactory });
                logInfo('Updating product in shopping', product);
                hydrateProducts([product]);
            },
        },
        cart: {
            updateProduct: (callback) => {
                const product = callback({ productFactory });
                logInfo('Updating product in cart', product);
                hydrateProducts([product]);
            },
            updateProductQuantity: ({ id, quantity }) => {
                const productsHydrated = productsHydratedSelector(getGlobalStore().getState());
                const units = flatten(Object.values(productsHydrated).map((p) => p.product_units));
                const productUnit = units.find((u) => String(u.unit_ext_id) === String(id));
                logInfo('Updating quantity in cart', {
                    id,
                    quantity,
                    productUnit,
                });
                updateUnitCartQuantity({
                    productUnit,
                    targetQuantity: quantity,
                });
            },
            configure: (options) => {
                configureCart(options);
                logInfo('Configuring Cart', options);
            },
            resetCart: () => {
                resetCart();
            },
        },
        video: {
            update: (callback) => {
                const storeActions = storeApi.getState().actions;
                const video = storeApi.getState().video;
                if (video?.encoded_id) {
                    const hydrated = callback({ videoFactory, productFactory });
                    if (hydrated) {
                        logInfo('Updating video with', hydrated);
                        storeActions.updateVideo?.({ video: hydrated });
                        if (hydrated.products) {
                            if (video.live_stream_id && isLiveStream(video)) {
                                storeActions.setLiveStreamProducts?.(video.live_stream_id, hydrated.products);
                            }
                            else {
                                storeActions.setVideoProducts?.({
                                    videoId: video.encoded_id,
                                    products: hydrated.products,
                                });
                            }
                        }
                    }
                }
            },
        },
    }), [
        configureCart,
        hydrateProducts,
        resetCart,
        storeApi,
        updateUnitCartQuantity,
    ]);
};
